import { ButtonProps } from 'antd';
import { FC, MouseEvent, useCallback, useState } from 'react';
import * as Icon from 'react-feather';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Popconfirm } from '../Popconfirm';
import { DividerHeaderButton } from './DividerHeaderButton';
import translations from './DividerHeaderDeleteButton.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'header-divider-delete-button',
);
addTranslations(translations);

interface DividerHeaderDeleteButtonProps extends ButtonProps {
  id: string;
  label: string;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  hasError?: boolean;
  disabled?: boolean;
}

export const DividerHeaderDeleteButton: FC<DividerHeaderDeleteButtonProps> = (
  props,
) => {
  const { id, label, onClick, hasError, disabled, ...rest } = props;
  const { t } = useTranslation();
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleButtonClick = useCallback(
    (event?: MouseEvent<HTMLElement>) => {
      if (!event) return;
      event.stopPropagation();
      onClick?.(event);
    },
    [onClick],
  );

  const showConfirm = useCallback(
    (_event?: MouseEvent<HTMLElement>) => {
      setOpenConfirm(true);
    },
    [setOpenConfirm],
  );

  if (!onClick) {
    return;
  }

  return (
    <Popconfirm
      id={`${id}-confirm`}
      title={t('confirm.title')}
      description={t('confirm.description')}
      okText={t('confirm.button.yes')}
      cancelText={t('confirm.button.no')}
      isOpen={openConfirm}
      onOpenChange={setOpenConfirm}
      onConfirm={handleButtonClick}
      placement="bottom-end"
    >
      <DividerHeaderButton
        id={`${id}-delete`}
        label={label}
        icon={<Icon.Trash2 size={18} />}
        onClick={showConfirm}
        hasError={hasError}
        disabled={disabled}
        {...rest}
      />
    </Popconfirm>
  );
};
